import _ from "lodash";
import React, { useState } from "react";
import classNames from "classnames";
import { Tag } from "@toddle-edu/ds-web";
import classes from "./StandardList.scss";
import AnimateHeight from "UIComponents/AnimateHeight";
import { useI18n } from "Hooks";
import { CaretDownFilled, CaretUpFilled } from "@toddle-edu/ds-icons";
import { getPracticesIdsMemoized } from "./utils";
import { animateHeightStyle } from "./StandardListStyles";
import PracticeList from "./PracticeList";
import { onEnterOrSpaceKeyDown } from "Utils";

const StandardList = props => {
  const [expandedStandards, setExpandedStandards] = useState([]);

  const {
    standards,
    updateSelectedPractices,
    areAllStandardsOpen,
    practiceListsCollection,
    itemDetails,
    cycleDetails,
    testId,
  } = props;

  const { t } = useI18n(["snp"]);

  const { disabledPractices, selectedPractices } = practiceListsCollection;

  const updateExpandedStandards = ({ isOpen, id }) => {
    if (!isOpen) {
      setExpandedStandards(expandedStandards => [...expandedStandards, id]);
    } else {
      setExpandedStandards(expandedStandards =>
        _.filter(expandedStandards, standardId => standardId !== id)
      );
    }
  };

  return (
    <ul className={classes.standardListContainer}>
      {_.map(standards, ({ id, label, practices }) => {
        const isOpen = _.includes(expandedStandards, id) || areAllStandardsOpen;

        const practicesIds = getPracticesIdsMemoized({ practices });

        const selectedPracticesOfStandardCount = _.size(
          _.intersection(selectedPractices, practicesIds)
        );

        const disabledPracticesOfStandardCount = _.size(
          _.intersection(disabledPractices, practicesIds)
        );

        const totalCount =
          selectedPracticesOfStandardCount + disabledPracticesOfStandardCount;

        const ArrowComponent = isOpen ? CaretUpFilled : CaretDownFilled;

        const standardLabelClasses = classNames(
          classes.standardLabel,
          "text-label"
        );

        const clickStandardContainerButtonLabel =
          totalCount > 0
            ? t("snp:label_practices_or_requirements", { label })
            : label;

        return (
          <li className={classes.container} key={id}>
            <div
              className={classes.clickStandardContainer}
              onClick={() => updateExpandedStandards({ isOpen, id })}
              data-test-id={`${testId}-standard-${id}`}
              onKeyDown={e => {
                onEnterOrSpaceKeyDown(e, () =>
                  updateExpandedStandards({ isOpen, id })
                );
              }}
              aria-label={clickStandardContainerButtonLabel}
              tabIndex="0"
              aria-expanded={isOpen}
              role="button"
              aria-describedby={`${testId}-standard-${id}`}
            >
              <div className={classes.standardLabelContainer}>
                <div className={classes.leftContainer}>
                  <div
                    dir="auto"
                    className={standardLabelClasses}
                  >{`${label}`}</div>

                  {totalCount > 0 && (
                    <span id={`${testId}-standard-${id}`}>
                      <Tag dsVersion="2.0" size="small">
                        {t("snp:count_tagged", { count: totalCount })}
                      </Tag>
                    </span>
                  )}
                </div>
                <div className={classes.rightContainer}>
                  <ArrowComponent size={"xx-small"} variant={"subtle"} />
                </div>
              </div>
            </div>
            <AnimateHeight
              duration={300}
              height={isOpen ? "auto" : 0}
              style={animateHeightStyle}
            >
              <div className={classes.practiceList}>
                <PracticeList
                  practices={practices}
                  testId={`${testId}-standard-${id}`}
                  updateSelectedPractices={updateSelectedPractices}
                  practiceListsCollection={practiceListsCollection}
                  itemDetails={itemDetails}
                  cycleDetails={cycleDetails}
                />
              </div>
            </AnimateHeight>
          </li>
        );
      })}
    </ul>
  );
};

export default StandardList;
